import { render, staticRenderFns } from "./TransactionViewGlobal.vue?vue&type=template&id=fc76d9da&scoped=true&"
import script from "./TransactionViewGlobal.vue?vue&type=script&lang=js&"
export * from "./TransactionViewGlobal.vue?vue&type=script&lang=js&"
import style0 from "./TransactionViewGlobal.vue?vue&type=style&index=0&id=fc76d9da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc76d9da",
  null
  
)

export default component.exports